<div class="popup">
  <h2>{{title}}</h2>
  <p>{{message}}</p>
  <button class="shadow btn ds-btn-confirmation" (click)="confirmChoice()">Confirmer</button>
  <br />
  <button class="shadow btn ds-btn-annulation" (click)="cancelChoice()">Annuler</button>
</div>
